<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="커뮤니티" src="/images/sub/subvisual-community.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--last">
            <template #title>미디어</template>

            <div class="board-search-wrap">
                <v-row justify="end" class="row--xs">
                    <v-col sm="auto">
                        <v-text-field v-model="filter.searchValue" dense hide-details outlined placeholder="검색어를 입력하세요." class="w-md-240px" />
                    </v-col>
                    <v-col cols="auto">
                        <v-btn @click="search" tile color="grey" style="border-radius:10px 0 10px 0;">검색</v-btn>
                    </v-col>
                </v-row>
            </div>

            <v-divider class="grey darken-4 mb-30px" style="border-width: 2px 0 0;" />
            <v-row data-aos="fade">
                <v-col v-for="board, idx in boards" :key="idx" cols="6" md="4">
                    <image-board @click="view(board._id)">
                        <template #image>
                                <v-img cover width="100%" :aspect-ratio="1 / 1" :src="board.thumb" class="grey lighten-5" />
                        </template>

                        <template #subject>
                            {{board.subject}}
                        </template>

                        <v-row class="row--xs">
                            <v-col cols="12">
                                <div class="font-size-14 grey--text text--lighten-1">{{$dayjs(board.createdAt).format("YYYY-MM-DD")}}</div>
                            </v-col>
                        </v-row>
                    </image-board>
                </v-col>
            </v-row>

            <div class="pagination-wrap">
                <v-pagination v-model="page" :length="pageCount" total-visible="5" @input="search(true)" />
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from '@/api';
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import ImageBoard from "@/components/dumb/image-board.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        ImageBoard,
    },
    props: {},
    data() {
        return {
            boards: [],
            page: this.$route.query.page || 1,
            pageCount: 1,
            limit: 9,
            filter:{
                code: "magazine",
                searchKey: "subject",
                searchValue: null
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },
        async search(){
            let { boards, summary } = await api.v1.boards.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });
            this.boards = boards;
            this.pageCount = Math.ceil(summary.totalCount / this.limit) || 1;
        },
        view(_board){
            this.$router.push(`/community/magazine/${_board}`);
        }
    },
};
</script>

<style lang="scss" scoped></style>
